import { cn } from "@babybjorn/ui";
import type { FC, HTMLAttributes } from "react";
import Link from "../../../../components/general/Link";
import Tag from "../../../../components/general/Tag";
import ImageContainer from "../../../general/ImageContainers";
import * as s from "./CatagoryItem.module.scss";

type CategoryItemProps = HTMLAttributes<HTMLAnchorElement> & {
	label: string;
	href?: string;
	onClick?: () => void;
	image: { src: string; alt?: string };
	tag?: string;
	isSliderItem?: boolean;
	active?: boolean;
};

const CategoryItem: FC<CategoryItemProps> = ({
	label,
	image,
	href,
	onClick,
	tag,
	isSliderItem = false,
	active = false,
}) => {
	if (href && onClick) return null;

	return href ? (
		<Link
			className={cn(s.item, {
				[s.sliderItem]: isSliderItem,
				[s.active]: active,
			})}
			aria-label={label}
			href={href}
		>
			<ItemContent image={image} label={label} tag={tag} />
		</Link>
	) : (
		<button
			onClick={onClick}
			className={cn(s.item, {
				[s.sliderItem]: isSliderItem,
				[s.active]: active,
			})}
			aria-label={label}
		>
			<ItemContent image={image} label={label} tag={tag} />
		</button>
	);
};

export default CategoryItem;

const ItemContent = ({
	image,
	label,
	tag,
}: {
	image: { src: string; alt?: string };
	label: string;
	tag?: string;
}) => {
	return (
		<>
			<ImageContainer
				width={240}
				alt={image.alt}
				imgSrc={image.src}
				ratio="square"
				sizes="(max-width: 990px) 20vw, 15vw"
				className={s.imageContainer}
				hidePlaceholder
			/>
			<div className={s.contentWrapper}>
				<label>{label}</label>
				{tag && <Tag label={tag} className={s.tag} />}
			</div>
		</>
	);
};
